import type { MenuItem } from '@/consts/navigation';
import { cn } from '@/utils/cn';
import { DownOutlined } from '@ant-design/icons';

import { useNavigationContext } from '../context/NavigationContext';
import { NavBadge } from './NavBadge';
import { NavMenuIcon } from './NavMenuIcon';

interface NavExpandedContentProps {
  item: MenuItem;
  translatedText: string;
}

export const NavExpandedContent = ({ item, translatedText }: NavExpandedContentProps) => {
  const { expandedSections } = useNavigationContext();

  const hasChildren = Boolean(item.children?.length);
  const isExpanded = expandedSections.has(item.text);

  return (
    <>
      <div className="flex min-w-0 flex-1 items-center gap-2.5">
        <NavMenuIcon item={item} />
        <span className="truncate text-left text-sm leading-tight uppercase">{translatedText}</span>
      </div>

      <NavBadge badge={item.badge} />

      {hasChildren && (
        <DownOutlined
          className={cn('size-3 flex-shrink-0 transition-transform duration-100', isExpanded && 'rotate-180')}
          aria-hidden="true"
        />
      )}
    </>
  );
};
